import { Dialog } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "../DialogsContents/DialogContentGeneric";
import { IDataIngredientesAtivos } from "../../../types/api/estoque/pesquisar-ingredientes-ativos";
import MultipleChipsField from "../../BaseInputs/MultipleChipsField";

interface SelectSimpleApiQueryProps {
    value: IDataIngredientesAtivos | IDataIngredientesAtivos[] | null;
    onChange: (arg: IDataIngredientesAtivos | IDataIngredientesAtivos[] | null) => void;
    error?: boolean;
    required?: boolean;
    unique_select?: boolean;
}

export default function SelectIngredienteAtivoMultiple({
    value,
    onChange,
    required = false,
    error = false,
    unique_select = false,
}: SelectSimpleApiQueryProps) {
    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => setOpenModal(false);

    // Normalize value for chips field
    const normalizedValue = value
        ? Array.isArray(value)
            ? value
            : [value]
        : [];

    return (
        <>
            <MultipleChipsField
                value={normalizedValue}
                required={required}
                label="Ingredientes ativos"
                formatChipLabel={(item) => `${item.id} - ${item.nome}`}
                onClick={() => setOpenModal(true)}
                error={!!error}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {openModal && (
                <Dialog
                    fullWidth
                    maxWidth="md"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        handleClose={handleClose}
                        multiple={!unique_select}
                        possuiBtnLimpar

                        title="Selecionar Ingrediente Ativo"
                        queryPath="receituario-agronomico/ingredientes-ativos/pesquisar-ingrediente-ativo"
                        getItemKey={(item) => item?.id ?? 0}
                        getItemLabel={(item) => item ? `${item.id} - ${item.nome}` : ''}
                        defaultValue={normalizedValue}
                        onChange={(selected) => {
                            if (unique_select) {
                                const arr = Array.isArray(selected) ? selected : selected ? [selected] : [];
                                onChange(arr.length > 0 ? arr[0] : null);
                            } else {
                                onChange(Array.isArray(selected) ? selected : selected ? [selected] : []);
                            }
                            handleClose();
                        }}
                    />
                </Dialog>
            )}
        </>
    );
}